import { getIsIssuesLoading } from '../../query/issues/index.tsx';
import { getPlan } from '../../query/plan/index.tsx';
import type { State } from '../../state/types.tsx';

export const mapStateToProps = (state: State) => ({
	creatorAccountId: getPlan(state).creatorAccountId,
	planType: getPlan(state).planType,
	isPlanLoading: getIsIssuesLoading(state),
});
